import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getMeta, BASE_URL, DEFAULT_OG } from '../seo';

// Один компонент, который по текущему пути ставит правильные title/description/OG/canonical.
// Рендерится один раз внутри роутера (в AppShell), работает и на клиенте, и при пререндере.
export default function Seo() {
  const { pathname } = useLocation();
  const meta = getMeta(pathname);
  const canonical = `${BASE_URL}${pathname === '/' ? '' : pathname}`;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={DEFAULT_OG} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={DEFAULT_OG} />
    </Helmet>
  );
}
